import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Button } from 'react-bootstrap';
import BasicFormInput from '../form/BasicFormInput';
import FormSelect from '../form/FormSelect';
import { GAME_OPTIONS, SPOILER_OPTIONS } from '../form/constants';

class PushNotificationsForm extends Component {
  constructor(props) {
    super(props);
    this.formatEntry = this.formatEntry.bind(this);
    this.parseEntryId = this.parseEntryId.bind(this);
  }

  formatEntry(value, name) {
    return value ? value.id : '';
  }

  parseEntryId(value, name) {
    return { id: Number(value) };
  }

  render() {
    const { handleSubmit, onSubmit } = this.props;

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Field
          type="text"
          label="Message"
          name="message"
          component={BasicFormInput}
        />
        <Field
          label="Game"
          name="game"
          component={FormSelect}
          options={GAME_OPTIONS}
        />
        <Field
          label="Spoilers"
          name="spoilers"
          component={FormSelect}
          options={SPOILER_OPTIONS}
        />
        <Field
          label="Entry ID"
          name="entry"
          type="number"
          component={BasicFormInput}
          format={this.formatEntry}
          parse={this.parseEntryId}
        />
        <Field
          type="checkbox"
          name="chat"
          placeholder="Send to Chat"
          normalize={v => !!v}
          component={BasicFormInput}
          controlId="chat"
          label="Sent to Chat"
        />
        <Button type="submit">
          Send push notification
        </Button>
      </form>
    );
  }
}

PushNotificationsForm.propTypes = {
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    initialValues: {
      spoilers: SPOILER_OPTIONS[0][0],
      game: GAME_OPTIONS[0][0],
    },
  };
}

export default connect(
  mapStateToProps,
)(reduxForm({ form: 'push_notifications' })(PushNotificationsForm));



// WEBPACK FOOTER //
// ./src/cms/notifications/PushNotificationsForm.js